import React from "react";

interface Props {
  video_source: any;
}

const VideoBox: React.FC<Props> = ({ video_source }: Props) => {
  return (
    <>
      <div className="video_outside">
        <video className="video_holder" src={video_source} controls autoPlay />
      </div>
    </>
  );
};

export default VideoBox;
